import store from 'store';
import actions from 'store/actions/routing';
import types from '../types/routing';

export const setLoading = async (loading) => {
  return store().dispatch(actions.setLoading(loading));
};
export const setConfirmDisabled = async (confirm) => {
  return store().dispatch(actions.setConfirmDisabled(confirm));
};

export const getSlotTemplates = async (queryString) => {
  return actions.getSlotTemplates(queryString);
};

export const deleteSlotTemplates = async (data) => {
  return actions.deleteSlotTemplates(data);
};

export const getZonesByStoreIdForRouting = async (payload) => {
  return actions.getZonesByStoreIdForRouting(payload);
};

export const getSlotsByZoneId = async (payload) => {
  return actions.getSlotsByZoneId(payload);
};

export const getCurrentSlotsByZoneId = async (zoneId) => {
  return actions.getCurrentSlotsByZoneId(zoneId);
};

export const getSlotsByDateRange = async (payload) => {
  return actions.getSlotsByDateRange(payload);
};

export const getOrdersBySlotIdForRouting = async (payload) => {
  return actions.getOrdersBySlotIdForRouting(payload);
};

export const getCouriersByZoneIdForRouting = async (id) => {
  return actions.getCouriersByZoneIdForRouting(id);
};

export const routeOrdersWithCouriers = async (payload) => {
  return actions.routeOrdersWithCouriers(payload);
};

export const getRouteTaskDetails = async (routeId) => {
  return actions.getRouteTaskDetails(routeId);
};

export const approveRouting = async (taskId) => {
  return actions.approveRouting(taskId);
};
export const getReasonTypes = async () => {
  return actions.getReasonTypes();
};

export const isRoutingComplete = async (taskId) => {
  return actions.isRoutingComplete(taskId);
};

export const setSelectedRoutingDetailData = (data) => {
  return store().dispatch({
    type: types.ROUTING_SET,
    key: 'selectedRoutingDetailData',
    data,
  });
};
export const getRoutingViewList = async (queryString) => {
  return actions.getRoutingViewList(queryString);
};

export const getRoutingViewListById = async (routeID) => {
  return actions.getRoutingViewListById(routeID);
};

export const isReRoutingReq = async (routeID) => {
  return actions.isReRoutingReq(routeID);
};

export const reRoutes = async (routeID) => {
  return actions.reRoutes(routeID);
};

export const transferOrdersForCourier = async (payload) => {
  return actions.transferOrdersForCourier(payload);
};

export const switchOrdersForCourier = async (payload) => {
  return actions.switchOrdersForCourier(payload);
};
export const removeRoutingViewListData = async (data) => {
  return actions.removeRoutingViewListData(data);
};
